/**
 * @module constants
 * @description Barrel export for application constants
 */

export { TITLE, SUBTITLE, TRACKING_PREFIX } from './constants';
